import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from '@/utils/cn';
import styles from './Tooltip.module.scss';
import type { TooltipProps } from './Tooltip.types';

/**
 * Tooltip - Displays informative text on hover
 * Built on Radix UI Tooltip primitive
 *
 * @example
 * <Tooltip content="Home">
 *   <button>Icon</button>
 * </Tooltip>
 */
export function Tooltip({
  children,
  content,
  side = 'right',
  sideOffset = 8,
  delayDuration = 200,
  showArrow = true,
  className,
}: TooltipProps) {
  return (
    <TooltipPrimitive.Provider delayDuration={delayDuration}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>
          {children}
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side={side}
            sideOffset={sideOffset}
            className={cn(styles.tooltip, className)}
          >
            {content}
            {showArrow && <TooltipPrimitive.Arrow className={styles.tooltip__arrow} />}
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}

Tooltip.displayName = 'Tooltip';
